<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="mt-5 pt-4 row justify-content-center">
        <div class="col-12 mb-3">
          <label style="color: #616161;"><strong>CREACIÓN DE LINKS</strong></label><br>
        </div>
        <div class="col-12 m-0 p-0">
          <div class="col-12 small-info">
            <small style="color:black;">Recuerda que los datos marcados con (*) son obligatorios</small>
          </div><br>
          <div class="form-group">
            <div class="row" style="text-align:left">
              <div class="col-12 m-0 p-0">
                <div style="margin:auto;" class="row">

                  <div class="col-8">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Descripción (opcional)</strong>
                      </label>
                      <input
                        type="text"
                        v-model="form.description"
                        class="form-control"
                        placeholder="Escribe aquí una corta descripción del link"
                      />
                    </div>
                  </div>

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Tipo de link *</strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.type_link }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.type_link"
                      >
                        <option value="null" disabled selected>Seleccione el tipo de link</option>
                        <option value="1">Registro</option>
                        <option value="2">Actualización de datos</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.type_link"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.type_link }}</span
                    >
                  </div>

                  <div v-if="form.type_link == 1" class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Destino de link *</strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.link_destination }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.link_destination"
                      >
                        <option value="null" disabled selected>Seleccione el destino del link</option>
                        <option value="1">landing/register</option>
                        <option value="2">quick/registration</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.link_destination"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.link_destination }}</span
                    >
                  </div>

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Cantidad de puntos *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.cant_points }"
                        type="number"
                        v-model="form.cant_points"
                        class="form-control"
                        placeholder="Escribe la cantidad de puntos"
                      />
                    </div>
                    <span
                      v-if="errors.cant_points"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.cant_points }}</span
                    >
                  </div>

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Fecha de vencimiento del link *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.expiration_date }"
                        type="date"
                        v-model="form.expiration_date"
                        class="form-control"
                        :min="getCurrentDate()"
                      />
                    </div>
                    <span
                      v-if="errors.expiration_date"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.expiration_date }}</span
                    >
                  </div>

                  <div v-if="form.type_link == 1" class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color:#616161; font-size:14px"
                      ><strong>Tipo de usuario *</strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.type_user }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.type_user"
                      >
                        <option value="null" disabled selected>Seleccione el tipo de usuario</option>
                        <option value="1">Motero</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.type_user"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.type_user }}</span
                    >
                  </div>

                  <div v-else class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color:#616161; font-size:14px"
                      ><strong>Tipo de usuario *</strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.type_user }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.type_user"
                      >
                        <option value="null" disabled selected>Seleccione el tipo de usuario</option>
                        <option value="1">Motero</option>
                        <option value="2">Lubricador</option>
                        <option value="3">Motero y Lubricador</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.type_user"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.type_user }}</span
                    >
                  </div>

                  <!-- se genera el link -->
                  <div style="margin:auto;" v-if="form.link_generated != null" class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color:#28a745; font-size:16px"
                      ><strong>Link generado</strong>
                      </label>
                      <input
                        type="text"
                        v-model="form.link_generated"
                        class="form-control"
                        placeholder="Link generado"
                        disabled
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3 mb-3" style="text-align:center">
          <button
            @click="clearForm()"
            type="button"
            class="btn btn-success btn-sm button-login mr-3"
          >
            Limpiar formulario
          </button>
          <button
            @click="createLink()"
            type="button"
            class="btn btn-danger btn-sm button-login"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Crear link</template>
          </button>
          <button
            @click="GoToHistory()"
            type="button"
            class="btn_history btn btn-sm button-login mr-3"
          >
            Historial de links
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";
  import axios from 'axios'

  export default {
    data() {
      return {
        form: {
          status: 1,
          description: "",
          type_link: null,
          link_destination: null, 
          cant_points: null,
          expiration_date: null,
          type_user: null,
          link: "",
          full_link: "",
          link_generated: null,
        },
        errors: {
          type_link: false,
          link_destination: false,
          cant_points: false,
          expiration_date: false,
          type_user: false,
        },
        loading: {
          changeDoc: false,
        },
      };
    },
    methods: {
      getCurrentDate() {
        const now = new Date();
        now.setDate(now.getDate() + 1); // add one day to allow for selecting today
        return now.toISOString().substr(0, 10);
      },
      clearForm(){
        this.form.description = "";
        this.form.type_link = null;
        this.form.link_destination = null;
        this.form.cant_points = null;
        this.form.expiration_date = null;
        this.form.type_user = null;
        this.form.link = "";
        this.form.full_link = "";
        this.form.link_generated = null;
        setTimeout(() => {
          this.errors.type_link = false;
          this.errors.link_destination = false;
          this.errors.cant_points = false;
          this.errors.expiration_date = false;
          this.errors.type_user = false;
        },0);
      },
      validForm(){
        let app = this;
        if(app.form.type_link == null){
          app.errors.type_link = "El tipo de link es requerido.";
          return false;
        }
        if(app.form.type_link != null && app.form.type_link == 1){
          if(app.form.link_destination == null){
            app.errors.link_destination = "El destino del link es requerido.";
            return false;
          }
        }
        if(app.form.cant_points == null){
          app.errors.cant_points = "La cantidad de puntos es requerida.";
          return false;
        }
        if(app.form.expiration_date == null){
          app.errors.expiration_date = "La fecha de vencimiento del link es requerida";
          return false;
        }
        if(app.form.type_user == null){
          app.errors.type_user = "El tipo de usuario es requerido.";
          return false;
        }
        return true;
      },
      createLink(){ 
        const formData = new FormData();
        formData.append("status", this.form.status);
        formData.append("description", this.form.description);
        formData.append("type_link", this.form.type_link);
        formData.append("link_destination", this.form.link_destination);
        formData.append("cant_points", this.form.cant_points);
        formData.append("expiration_date", this.form.expiration_date);
        formData.append("type_user", this.form.type_user);
        formData.append("link", this.form.link);
        formData.append("full_link", this.form.full_link);
        if(this.validForm()){
          this.loading.changeDoc = true;
          axios
          .post("superAdmin/create/links", formData)
          .then((res) => {
            // console.log('res.data: ', JSON.stringify(res.data));
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.loading.changeDoc = false;
              this.clearForm();
              this.getLinks();
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
        }
      },
      getLinks(){
        axios
        .get("api/get/links")
        .then((res) => {
          console.log('res.data: ', JSON.stringify(res.data));
          if (res.data.cod == 0){
            let link = res.data.data;
            this.form.link_generated = link.full_link;
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
      },
      GoToHistory(){
        this.$router.push({ name: "historyLinks" });
      },
    },
    watch: {
      "form.type_link": function(newV) {
        if (!newV) {
          this.errors.type_link = "El tipo de link es requerido.";
        } else {
          this.errors.type_link = false;
        }
      },
      "form.link_destination": function(newV) {
        if (!newV) {
          this.errors.link_destination = "El destino del link es requerido.";
        } else {
          this.errors.link_destination = false;
        }
      },
      "form.cant_points": function(newV) {
        if (!newV) {
          this.errors.cant_points = "La cantidad de puntos es requerida.";
        } else {
          this.errors.cant_points = false;
        }
      },
      "form.expiration_date": function(newV) {
        if (!newV) {
          this.errors.expiration_date = "La fecha de vencimiento del link es requerida";
        } else {
          this.errors.expiration_date = false;
        }
      },
      "form.type_user": function(newV) {
        if (!newV) {
          this.errors.type_user = "El tipo de usuario es requerido.";
        } else {
          this.errors.type_user = false;
        }
      },
    },
    mounted(){

    },
  };
</script>
  
<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
 padding-right: 0px !important;
 padding-left: 0px !important;
 overflow: hidden;
}

.hr-border {
 border-top: 1px solid rgb(198 198 198);
 height: 15px;
 width: 100%;
 background-color: white;
}

.div-button {
 margin-top: 50px;
 text-align: left;
}

.is-danger {
 border: solid 2px !important;
 border-color: #e9434c !important;
}

.modal-title {
 color: black;
 font-weight: bold;
}

.modal-question {
 border: solid 3px;
 border-color: #dc3545;
 border-radius: 15px;
}

label {
 color: black;
 margin-right: 4px;
}

.img-banner {
 display: block;
 width: 25%;
 text-align: center;
 margin: auto;
}

td {
 text-align: center;
 vertical-align: -webkit-baseline-middle;
 cursor: all-scroll;
}

.table-container {
 overflow: auto;
}

h5 {
 margin-bottom: 10px !important;
}

.commentary {
 text-align: left;
 color: #1da5df;
 font-size: 13px;
}

.page-item.active .page-link {
 border-style: none;
 border-radius: 20px;
 background-color: #dc3545;
}

a.page-link {
 color: black;
 cursor: pointer;
}

a.page-link:hover {
 color: #dc3545;
}

.page-link {
 background-color: #f5f5dc00;
 border-radius: 20px;
 border-color: none;
}

.page-item.disabled .page-link {
 color: #dc3545;
 background-color: #fff0;
 border-color: #dee2e600;
}

.ul-pagination {
 padding: 0px;
}

.multiselect__tag {
 background-color: #dc3545 !important;
}
.multiselect__tag-icon:after {
 color: #ffffff;
 font-size: 18px;
}
.multiselect__tag-icon:hover {
 color: #ffffff;
 font-size: 18px;
 background-color: #b80012;
}

.multiselect__option--highlight {
 background: #17a2b8;
 outline: none;
 color: #fff;
}
.alert-danger {
 border-color: red !important;
}
.btn_history{
  margin:0px 0px 0px 20px;
  background-color:#17a2b8;
}
</style>